export interface SerialLineBuffer {
  push: (chunk: string) => void;
  flush: () => void;
  clear: () => void;
}

function findLineBreak(buffer: string): { index: number; length: number } | null {
  const crlfIndex = buffer.indexOf('\r\n');
  const lfIndex = buffer.indexOf('\n');
  const crIndex = buffer.indexOf('\r');

  let index = -1;
  let length = 0;

  if (crlfIndex !== -1) {
    index = crlfIndex;
    length = 2;
  }

  if (lfIndex !== -1 && (index === -1 || lfIndex < index)) {
    index = lfIndex;
    length = 1;
  }

  if (crIndex !== -1 && (index === -1 || crIndex < index)) {
    index = crIndex;
    length = 1;
  }

  return index === -1 ? null : { index, length };
}

export function createSerialLineBuffer(onLine: (line: string) => void): SerialLineBuffer {
  let buffer = '';

  const emitLines = () => {
    while (true) {
      const lineBreak = findLineBreak(buffer);
      if (!lineBreak) {
        return;
      }

      const line = buffer.slice(0, lineBreak.index);
      buffer = buffer.slice(lineBreak.index + lineBreak.length);
      onLine(line);
    }
  };

  return {
    push(chunk: string) {
      if (!chunk) {
        return;
      }

      buffer += chunk;
      emitLines();
    },
    flush() {
      if (!buffer) {
        return;
      }

      onLine(buffer);
      buffer = '';
    },
    clear() {
      buffer = '';
    },
  };
}
